module.exports = __webpack_public_path__ + "img/tavle-fade.e820b957.png";